import { render, staticRenderFns } from "./emolumentoTurma.vue?vue&type=template&id=db35a8aa&scoped=true&"
import script from "./emolumentoTurma.vue?vue&type=script&lang=js&"
export * from "./emolumentoTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db35a8aa",
  null
  
)

export default component.exports